import React from "react";
import { alpha } from "@mui/material/styles";
import { Box, Tabs, Tab, Menu, MenuItem } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { ExpandMore } from "@mui/icons-material";
import AuthButton from "../components/AuthButton";

const CustomTab = (props) => {
  const location = useLocation();
  const isActive = location.pathname === `/${props.to}`;

  return (
    <Tab
      component={props.component || Link}
      {...props}
      sx={{
        minHeight: 41,
        whiteSpace: "nowrap",
        textTransform: "none",
        letterSpacing: { xs: 0, sm: 0, md: "2px", lg: "2px" },
        opacity: 1,
        color: isActive ? "#5B7195" : props.color || "#9aa2ae",
        fontWeight: isActive ? 600 : 400,
        borderBottom: isActive ? "2px solid #5B7195" : "none",
        backgroundColor: isActive ? alpha("#5B7195", 0.15) : "transparent",
        "&:hover": {
          opacity: 0.5,
          backgroundColor: isActive
            ? alpha("#5B7195", 0.2)
            : alpha("#fff", 0.1),
        },
      }}
    />
  );
};

class AppBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tab: false };
  }

  handleChange = (event, value) => {
    if (value !== 2) {
      this.setState({ tab: value, anchorEl: null });
    }
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleNav = () => {
    this.setState({ anchorEl: null, tab: 2 });
  };

  render() {
    const location = this.props.location || { pathname: "" };
    return (
      <Box
        sx={{
          backgroundColor: "#4b4b4b",
          width: "100%",
          position: "relative",
          display: { xs: "none", sm: "block" },
        }}
      >
        <Tabs
          centered
          value={this.state.tab}
          onChange={this.handleChange}
          indicatorColor="#9aa2ae"
          sx={{ minHeight: 41 }}
        >
          <CustomTab to="gallery" label="View Gallery" />
          <CustomTab to="browsedesigns" label="Browse Designs" />
          {/*<CustomTab*/}
          {/*component="a"*/}
          {/*label={*/}
          {/*<div>*/}
          {/*Services*/}
          {/*<ExpandMore sx={{ fontSize: 14 }} />*/}
          {/*</div>*/}
          {/*}*/}
          {/*onClick={this.handleClick}*/}
          {/*/>*/}
          <CustomTab to="customplans" label="View Process" />
          {/*<CustomTab to="pricing" label="Pricing" />*/}
          <CustomTab to="requestquote" label="Request Quote" color="#5B7195" />
        </Tabs>
        <AuthButton />
        <Menu
          id="nav-menu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
          sx={{
            ".MuiPaper-root": {
              borderRadius: 0,
              backgroundColor: alpha("#4b4b4b", 0.8),
            },
          }}
        >
          <MenuItem
            sx={{
              opacity: "1 !important",
              color: "white",
              backgroundColor:
                location.pathname === "/customplans"
                  ? alpha("#5B7195", 0.4)
                  : "transparent",
            }}
            component={Link}
            to="customplans"
            onClick={this.handleNav}
          >
            Custom Plans
          </MenuItem>
          <MenuItem
            sx={{
              opacity: "1 !important",
              color: "white",
              backgroundColor:
                location.pathname === "/additions"
                  ? alpha("#5B7195", 0.4)
                  : "transparent",
            }}
            component={Link}
            to="additions"
            onClick={this.handleNav}
          >
            Additions + Remodels
          </MenuItem>
          <MenuItem
            sx={{
              opacity: "1 !important",
              color: "white",
              backgroundColor:
                location.pathname === "/renderings"
                  ? alpha("#5B7195", 0.4)
                  : "transparent",
            }}
            component={Link}
            to="renderings"
            onClick={this.handleNav}
          >
            Renderings
          </MenuItem>
          <MenuItem
            sx={{
              opacity: "1 !important",
              color: "white",
              backgroundColor:
                location.pathname === "/stockplans"
                  ? alpha("#5B7195", 0.4)
                  : "transparent",
            }}
            component={Link}
            to="stockplans"
            onClick={this.handleNav}
          >
            Stock Plans
          </MenuItem>
        </Menu>
      </Box>
    );
  }
}

// Wrapper component to provide location
const AppBarWithLocation = (props) => {
  const location = useLocation();
  return <AppBar {...props} location={location} />;
};

export default AppBarWithLocation;
